import styled from 'styled-components'

import Flex from 'components/reusable/flex'

const ModalStandardWrapper = styled(Flex)`
  flex-direction: column;
  flex-wrap: nowrap;
  max-width: min(480px, 100vw);
  min-width: ${({ $minWidth }) => ($minWidth ? $minWidth : '320px')};
  width: 100%;
  padding: 56px 56px 40px;
  position: relative;
  @media (max-width: 768px) {
    min-width: 100vw;
    max-width: 100vw;
    padding: 24px 16px 16px;
  }
`

export default ModalStandardWrapper
